export const SYSTEM_WP = "SYSTEM.WP";
export const MENU_PAYMENTLOAD = "MENU.PAYMENT_LOAD";
export const MENU_PAYMENTLOAD_WRITE = "MENU.PAYMENT_LOAD.WRITE";
export const MENU_BILLS = "MENU.BILLS";
export const MENU_BILLS_WRITE = "MENU.BILLS.WRITE";
export const MENU_PAYMENTS = "MENU.PAYMENTS";
export const MENU_PAYMENTS_WRITE = "MENU.PAYMENTS.WRITE";
export const MENU_CHARGES = "MENU.CHARGES";
export const MENU_CHARGES_WRITE = "MENU.CHARGES.WRITE";
export const MENU_ACCOUNT_ACCOUNTINFO = "MENU.ACCOUNT.ACCOUNT_INFO";
export const MENU_ACCOUNT_ACCOUNTINFO_WRITE = "MENU.ACCOUNT.ACCOUNT_INFO.WRITE";
export const MENU_ACCOUNT_AGREEMENT = "MENU.ACCOUNT.AGREEMENT";
export const MENU_ACCOUNT_AGREEMENT_WRITE = "MENU.ACCOUNT.AGREEMENT.WRITE";
export const MENU_ACCOUNT_SERVICES = "MENU.ACCOUNT.SERVICES";
export const MENU_ACCOUNT_SERVICES_WRITE = "MENU.ACCOUNT.SERVICES.WRITE";
export const MENU_ACCOUNT_BILLS = "MENU.ACCOUNT.BILLS";
export const MENU_ACCOUNT_BILLS_WRITE = "MENU.ACCOUNT.BILLS.WRITE";
export const MENU_ACCOUNT_PAYMENTS = "MENU.ACCOUNT.PAYMENTS";
export const MENU_ACCOUNT_PAYMENTS_WRITE = "MENU.ACCOUNT.PAYMENTS.WRITE";
export const MENU_ACCOUNT_CHARGES = "MENU.ACCOUNT.CHARGES";
export const MENU_ACCOUNT_CHARGES_WRITE = "MENU.ACCOUNT.CHARGES.WRITE";
export const MENU_ACCOUNT_TRANSACTION = "MENU.ACCOUNT.TRANSACTION";
export const MENU_ACCOUNT_TRANSACTION_WRITE = "MENU.ACCOUNT.TRANSACTION.WRITE";
export const MENU_ACCOUNTS = "MENU.ACCOUNTS";
export const MENU_ACCOUNTS_WRITE = "MENU.ACCOUNTS.WRITE";
export const MENU_ACCOUNTS_ORGANIZATION = "MENU.ACCOUNTS.ORGANIZATION";
export const MENU_ACCOUNTS_ORGANIZATION_WRITE = "MENU.ACCOUNTS.ORGANIZATION.WRITE";
export const MENU_ACCOUNTS_INDIVIDUAL = "MENU.ACCOUNTS.INDIVIDUAL";
export const MENU_ACCOUNTS_INDIVIDUAL_WRITE = "MENU.ACCOUNTS.INDIVIDUAL.WRITE";
export const MENU_SERVICES = "MENU.SERVICES";
export const MENU_SERVICES_WRITE = "MENU.SERVICES.WRITE";
export const MENU_TASKMANAGER = "MENU.TASK_MANAGER";
export const MENU_TASKMANAGER_WRITE = "MENU.TASK_MANAGER.WRITE";
export const MENU_BILLING_TRAFFIC = "MENU.BILLING.TRAFFIC";
export const MENU_BILLING_TRAFFIC_WRITE = "MENU.BILLING.TRAFFIC.WRITE";
export const MENU_BILLING_ACCOUNTINGSYSTEM = "MENU.BILLING.ACCOUNTING_SYSTEM";
export const MENU_BILLING_ACCOUNTINGSYSTEM_WRITE = "MENU.BILLING.ACCOUNTING_SYSTEM.WRITE";
export const MENU_BILLING_PREPAYMENTBILL = "MENU.BILLING.PREPAYMENT_BILL";
export const MENU_BILLING_PREPAYMENTBILL_WRITE = "MENU.BILLING.PREPAYMENT_BILL.WRITE";
export const MENU_BILLING_BILLINGPROCEDURES = "MENU.BILLING.BILLING_PROCEDURES";
export const MENU_BILLING_BILLINGPROCEDURES_WRITE = "MENU.BILLING.BILLING_PROCEDURES.WRITE";
export const MENU_ADMIN_DIC = "MENU.ADMIN.DIC";
export const MENU_ADMIN_DIC_WRITE = "MENU.ADMIN.DIC.WRITE";
export const MENU_ADMIN_EXCHANGE = "MENU.ADMIN.EXCHANGE";
export const MENU_ADMIN_EXCHANGE_WRITE = "MENU.ADMIN.EXCHANGE.WRITE";
export const MENU_ADMIN_SERVICEBILLINGPROFILE = "MENU.ADMIN.SERVICE_BILLING_PROFILE";
export const MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE = "MENU.ADMIN.SERVICE_BILLING_PROFILE.WRITE";
export const MENU_ADMIN_SERVICETYPE = "MENU.ADMIN.SERVICE_TYPE";
export const MENU_ADMIN_INFOTEMPLATE = "MENU.ADMIN.INFO_TEMPLATE";
export const MENU_ADMIN_INFOTEMPLATE_WRITE = "MENU.ADMIN.INFO_TEMPLATE.WRITE";
export const MENU_ADMIN_SERVICETYPE_WRITE = "MENU.ADMIN.SERVICE_TYPE.WRITE";
export const MENU_USER_USERMANAGEMENT = "MENU.USER.USER_MANAGEMENT";
export const MENU_USER_USERMANAGEMENT_WRITE = "MENU.USER.USER_MANAGEMENT.WRITE";
export const MENU_USER_USERALERTS = "MENU.USER.USER_ALERTS";
export const MENU_USER_USERALERTS_WRITE = "MENU.USER.USER_ALERTS.WRITE";
export const MENU_USER_HELP = "MENU.USER.HELP";
export const MENU_USER_HELP_WRITE = "MENU.USER.HELP.WRITE";
export const MENU_ADMIN_TENANT = "MENU.ADMIN.TENANT";
export const MENU_ADMIN_TENANT_WRITE = "MENU.ADMIN.TENANT.WRITE";
export const MENU_ADMIN_PROPERTY_TYPE = "MENU.ADMIN.PROPERTY_TYPE";
export const MENU_ADMIN_PROPERTY_TYPE_WRITE = "MENU.ADMIN.PROPERTY_TYPE.WRITE";
export const AGREEMENT_CREATE = "AGREEMENT.CREATE";
export const MENU_BILLING_ROLLBACK = "MENU.BILLING.ROLLBACK";
export const MENU_BILLING_ROLLBACK_WRITE = "MENU.BILLING.ROLLBACK.WRITE";
export const MENU_ACCOUNT_AGG_USAGE = "MENU.ACCOUNT.AGG_USAGE";
export const MENU_ACCOUNT_AGG_USAGE_WRITE = "MENU.ACCOUNT.AGG_USAGE.WRITE";
export const ACCOUNT_CREATE = "ACCOUNT.CREATE";
export const MENU_ACCOUNT_TRANSACTION_REPROCESS = "MENU.ACCOUNT.TRANSACTION.REPROCESS";
export const MENU_ADMIN_OFFERING = "MENU.ADMIN.OFFERING";
export const MENU_ADMIN_OFFERING_WRITE = "MENU.ADMIN.OFFERING.WRITE";
export const MENU_TC_ACCOUNT_AGREEMENT_TARIFF = "MENU.TC.ACCOUNT.AGREEMENT.TARIFF";
export const MENU_TC_ACCOUNT_AGREEMENT_TARIFF_WRITE = "MENU.TC.ACCOUNT.AGREEMENT.TARIFF.WRITE";
export const MENU_TC_ADMIN_DESTINATIONS = "MENU.TC.ADMIN.DESTINATIONS";
export const MENU_TC_ADMIN_DESTINATIONS_WRITE = "MENU.TC.ADMIN.DESTINATIONS.WRITE";
export const MENU_TC_ROUTING_ORDERS = "MENU.TC.ROUTING.ORDERS";
export const MENU_TC_ROUTING_ORDERS_WRITE = "MENU.TC.ROUTING.ORDERS.WRITE";
export const MENU_TC_ROUTING_ROUTING_PLAN = "MENU.TC.ROUTING.ROUTING_PLAN";
export const MENU_TC_ROUTING_ROUTING_PLAN_WRITE = "MENU.TC.ROUTING.ROUTING_PLAN.WRITE";
export const PROLONGATION_WRITE = "PROLONGATION.WRITE";
export const MENU_PAYMENTS_BALANCE_TRANSFER = "MENU.PAYMENTS.BALANCE_TRANSFER";
export const BLOCKING_DEBTS_DEACTIVATION = "BLOCKING.DEBTS.DEACTIVATION";
export const MENU_ADMIN_BLOCKING_TYPE_WRITE = "MENU.ADMIN.BLOCKING_TYPE.WRITE";
export const MENU_ADMIN_BLOCKING_TYPE = "MENU.ADMIN.BLOCKING_TYPE";
export const OFFERING_PRICE_CHANGE = "OFFERING.PRICE.CHANGE";
export const MENU_REPORTS_WRITE = "MENU.REPORTS.WRITE";
export const MENU_REPORTS = "MENU.REPORTS";
export const MENU_ADMIN_OFFERING_POLICY = "MENU.ADMIN.OFFERING_POLICY";
export const MENU_ADMIN_OFFERING_POLICY_WRITE = "MENU.ADMIN.OFFERING_POLICY.WRITE";
export const POLICY_EXTENDED_EDIT = "POLICY.EXTENDED.EDIT";
export const MENU_ADMIN_OFFERING_GROUP = "MENU.ADMIN.OFFERING_GROUP";
export const MENU_ADMIN_OFFERING_GROUP_WRITE = "MENU.ADMIN.OFFERING_GROUP.WRITE";
export const OFFERING_PRICE_NEGATIVEAMOUNT = "OFFERING.PRICE.NEGATIVEAMOUNT";
export const USER_PASSWORD_FORCE_CHANGE = "USER.PASSWORD.FORCE_CHANGE";
export const MENU_ADMIN_CHAR_TYPE = "MENU.ADMIN.CHAR_TYPE";
export const MENU_ADMIN_CHAR_TYPE_WRITE = "MENU.ADMIN.CHAR_TYPE.WRITE";
export const MENU_ADMIN_OBJECT_CHAR_TYPE = "MENU.ADMIN.OBJECT_CHAR_TYPE";
export const MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE = "MENU.ADMIN.OBJECT_CHAR_TYPE.WRITE";
export const MENU_ADMIN_REPORT_TEMPLATE_READ = "MENU.ADMIN.REPORT_TEMPLATE.READ";
export const MENU_ADMIN_REPORT_TEMPLATE = "MENU.ADMIN.REPORT_TEMPLATE";
export const MENU_ADMIN_FLEX_ENTITY = "MENU.ADMIN.FLEX.ENTITY";
export const MENU_ADMIN_FLEX_USEROBJECT = "MENU.ADMIN.FLEX.USEROBJECT";
export const ACCOUNTS_REG_PAYMENT = "ACCOUNTS.REG_PAYMENT";
export const PAYMENTS_REG_PAYMENT = "PAYMENTS.REG_PAYMENT";
export const USERMANAGEMENT_USER_CREATE = "USER_MANAGEMENT.USER.CREATE";
export const USERMANAGEMENT_USER_ACTIONS = "USER_MANAGEMENT.USER.ACTIONS";
export const USERMANAGEMENT_USER_ROLES = "USER_MANAGEMENT.USER.ROLES";
export const USERMANAGEMENT_USER_PERMISSIONS = "USER_MANAGEMENT.USER.PERMISSIONS";
export const USERMANAGEMENT_ROLES = "USER_MANAGEMENT.ROLES";
export const SERVICE_CHANGE_CHILDSTATUSES = "SERVICE.CHANGE.CHILDSTATUSES";
export const BILLING_ACCOUNTING_SYSTEM_PROCEDURES = "BILLING.ACCOUNTING_SYSTEM.PROCEDURES";
export const BILLING_ACCOUNTING_SYSTEM_EXTNUM = "BILLING.ACCOUNTING_SYSTEM.EXTNUM";
export const BILLING_ACCOUNTING_SYSTEM_TASKS = "BILLING.ACCOUNTING_SYSTEM.TASKS";
export const BILLING_ACCOUNTING_SYSTEM_EXPORT = "BILLING.ACCOUNTING_SYSTEM.EXPORT";
